// Countdown.js
import React from 'react';

const CountdownItem = ({ label, value, backgroundColor }) => {

  return (
    <div
      style={{
        backgroundColor,
        padding: '10px',
        margin: '10px',
        borderRadius: '5px',
        textAlign: 'center',
        transition: 'transform 1.5s ease',
        transform: 'rotateY(0deg)',
      }}
    >
      <div style={{ color: '#FFFFFF', fontSize: '34px', fontWeight: 'bold' }}>{value}</div>
      <div style={{ color: '#DDDDDD', width: '56px' }}>{label}</div>
    </div>
  );
};

export default CountdownItem;
